<template>
  <div class="home">
    <div
      v-if="bademon"
      style="
        position: fixed;
        top: 0;
        z-index: 2001;
        height: 100vh;
        width: 100vw;
        background-color: rgba(204, 204, 204, 0.7);
      "
    ></div>
    <div
      v-if="bademon"
      style="
        width: 346px;
        height: 320px;
        background-color: #fff;
        position: fixed;
        top: 30%;
        left: calc(50% - 173px);
        z-index: 2002;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;

        /* padding: 38px;
        box-sizing: border-box; */
      "
    >
      <i
        class="el-icon-close"
        style="position: absolute; top: 10px; right: 10px"
        @click="unInquiry()"
      ></i>
      <div
        style="font-size: 20px; color: rgba(51, 51, 51, 1); font-weight: 500"
      >
        免费定制专属网校
      </div>
      <el-select
        v-model="value"
        placeholder="请选择您所在的行业"
        style="height: 40px; width: 270px; margin: 24px 0 16px 0"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请输入您的联系方式"
        style="height: 40px; width: 270px"
      ></el-input>
      <div
        style="
          height: 40px;
          width: 270px;
          font-size: 14px;
          color: #0274f7;
          margin: 10px 0 20px 0;
        "
      >
        提交即可获取30天免费试用
      </div>
      <el-button
        @click="submitPhone"
        type="primary"
        style="
          height: 40px;
          width: 270px;
          background-color: #0274f7;
          color: #fff;
        "
        >提交</el-button
      >
    </div>
    <div v-if="screenWidth" class="one_a">
      <img src="../assets/official/person.png" alt="" class="one_b" />
      <div class="one_c">
        <!-- <div class="one_d">
          <img src="../assets/official/weixin.png" alt="" class="img" />
          <div class="div">在线咨询</div>
        </div> -->
        <div class="one_d">
          <!-- <img src="../assets/official/phoneTo.png" alt="" class="img" /> -->
          <img src="../assets/official/weixin.png" alt="" class="img" />
          <div class="div">企微联系</div>
          <div class="telephone">
            <div>
              <!-- <h4>咨询热线：</h4>
              <p>服务时间：09:00-21:00</p> -->
              <img
                style="height: 100px; width: 100px"
                src="../assets/official/qw.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <el-link target="_blank">
          <div class="one_d top">
            <img src="../assets/official/Vector.png" alt="" class="img" />
            <div @click="inquiry()" class="div1">免费试用</div>
          </div>
        </el-link>
      </div>
      <!-- <div
        v-if="TopUp"
        :class="[
          'topBack',
          'animate__animated',
          TopUp == 1 ? 'animate__fadeInUpBig' : '',
          TopUp == 2 ? 'animate__fadeOutDownBig' : '',
        ]"
        @click="handleClickTop()"
      >
        <img src="../assets/HelloWorld/dingbu_1.png" alt="" class="img" />
        <div class="div">回到顶部</div>
      </div> -->
    </div>
    <div v-if="screenWidth" class="navigationBar">
      <HelloWorld></HelloWorld>
    </div>
    <div v-if="!screenWidth" class="navigationBar">
      <toubuTop></toubuTop>
    </div>
    <div v-if="screenWidth">
      <div v-if="$route.path.replace('/', '') === ''" style="width: 100%">
        <div class="named" style="background: #ffffff">
          <LunBoVue></LunBoVue>
        </div>
        <!-- <div class="named" style="background: #ffffff">
          <LunBoVue2></LunBoVue2>
        </div> -->
        <!-- <div class="named" style="background: #ffffff">
          <LunBoVue3></LunBoVue3>
        </div>
        <div class="named" style="background: #ffffff">
          <LunBoVue4></LunBoVue4>
        </div> -->
        <div style="background: #fff">
          <KnowledgeVue></KnowledgeVue>
        </div>
        <div class="named" style="background: #fff">
          <KnowledgeVue4></KnowledgeVue4>
        </div>
        <div class="named" style="background: #ffffff">
          <SchemeVue4></SchemeVue4>
        </div>
        <!-- <div class="named" style="background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%)">
          <KnowledgeVue2></KnowledgeVue2>
        </div> -->
        <div class="named" style="background: #ffffff">
          <SolutionVue></SolutionVue>
        </div>
        <div class="named" style="background: #ffffff">
          <CostingVue></CostingVue>
        </div>
        <div class="named">
          <CostingVue5></CostingVue5>
        </div>
        <!-- <div class="named" style="background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%)">
          <SchemeVue2></SchemeVue2>
        </div> -->
        <!-- <div class="named" style="background: #ffffff">
          <SchemeVue3></SchemeVue3>
        </div> -->
        <!-- <div class="named" style="background: #ffffff">
          <SchemeVue></SchemeVue>
        </div>
        <div class="named" style="background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%)">
          <SafetyVue></SafetyVue>
        </div>
        <div class="named" style="background: #ffffff">
          <UpgradeVue></UpgradeVue>
        </div>
        <div class="named" style="background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%)">
          <UpgradeVue2></UpgradeVue2>
        </div> -->

        <div
          class="named"
          style="background: #252525"
          :class="bottomBox ? '' : 'noShowBottom'"
        >
          <BottomVue></BottomVue>
        </div>
        <div class="named" style="background: #252525">
          <BottomBossVue></BottomBossVue>
        </div>
      </div>
      <router-view v-else></router-view>
    </div>
    <div v-if="!screenWidth" class="one_one">
      <div class="one_one_1">
        <div class="one_one_2" style="padding: 0 0 0 32px">
          <img src="../assets/yidong/222223.png" alt="" />
          <el-link
            :href="http"
            target="_blank"
            style="width: 100%"
            @click.native="handleClick2"
          >
            <div style="color: #fff; font-size: 16px">免费体验</div>
          </el-link>
        </div>
        <img
          src="../assets/HelloWorld/huidong.gif"
          alt=""
          style="width: 59px; height: 59px; margin: 7px 0 0"
          @click="dialNumber()"
        />
        <div class="one_one_2" style="padding: 0 32px 0 0">
          <img src="../assets/yidong/3232.png" alt="" />
          <el-link
            href="https://affim.baidu.com/unique_49847201/mobile/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6"
            target="_self"
            style="width: 100%"
          >
            <div style="color: #fff; font-size: 16px">立即咨询</div>
          </el-link>
        </div>
      </div>
    </div>
    <div v-if="!screenWidth">
      <div
        v-if="
          $route.path !== '/schemeA' &&
          $route.path !== '/schemeB' &&
          $route.path !== '/schemeC'
        "
        style="width: 100%"
      >
        <div>
          <one_1Vue></one_1Vue>
        </div>
      </div>
      <router-view v-else></router-view>
    </div>
    <div
      v-if="
        screenWidth &&
        mianfei &&
        $route.path !== '/details' &&
        $route.path !== '/details2'
      "
      class="screenWidth2222"
    >
      <div class="BossTop9" style="cursor: default">
        <!-- <div class="BossTop8">
          <div class="BossTop5">
            <div style="display: flex">
              <el-input
                v-model="input"
                placeholder="请输入您的手机号码"
                class="yueon"
              ></el-input>
              <div class="yueon3" @click="dianhuan()">免费试用</div>
            </div>
          </div>
        </div> -->
        <el-dialog
          class="asdf"
          :modal="false"
          :visible.sync="dialogVisible"
          :before-close="handleClose"
        >
          <img
            src="../assets//HelloWorld//tankuang111.png"
            alt=""
            style="width: 114px; height: 112px; padding: 32px 0 16px"
          />
          <div class="xxx_top">提交成功 ！</div>
          <div class="xxx_topy">我们会尽快安排专属人员为您服务~</div>
          <div class="xxx_topu">
            <div class="xxx_topu22" @click="dialogVisible = false">知道了</div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import remoteJs from '@/components/remote/remoteJs.vue'
import HelloWorld from '@/components/HelloWorld'
import one_1Vue from '@/yidong/one_1'
import toubuTop from '@/yidong/toubu'
import LunBoVue from '@/components/LunBo'
// import LunBoVue2 from "@/components/LunBo2"
import LunBoVue3 from '@/components/LunBo3'
import LunBoVue4 from '@/components/LunBo4'
import SolutionVue from '@/components/SolutionTop'
import SchemeVue from '@/components/SchemeTop'
import SchemeVue2 from '@/components/SchemeTop2'
import SchemeVue3 from '@/components/SchemeTop3'
import SchemeVue4 from '@/components/SchemeTop4'
import KnowledgeVue from '@/components/Knowledge.vue'
import KnowledgeVue2 from '@/components/Knowledge2.vue'
import KnowledgeVue4 from '@/components/Knowledge4.vue'
import SafetyVue from '@/components/Safety.vue'
import CostingVue from '@/components/Costing.vue'
import CostingVue5 from '@/components/Costing5.vue'
import UpgradeVue from '@/components/Upgrade.vue'
import UpgradeVue2 from '@/components/Upgrade2.vue'
import BottomVue from '@/components/Bottom'
import BottomBossVue from '@/components/BottomBoss'
import Cookies from 'js-cookie'
import { report, fff } from '@/js/utils'
import { add } from '../api/util'

export default {
  name: 'HomeView',
  components: {
    toubuTop,
    one_1Vue,
    remoteJs,
    HelloWorld,
    LunBoVue,
    // LunBoVue2,
    LunBoVue3,
    LunBoVue4,
    SolutionVue,
    SchemeVue,
    SchemeVue2,
    SchemeVue3,
    SchemeVue4,
    KnowledgeVue,
    KnowledgeVue2,
    KnowledgeVue4,
    SafetyVue,
    CostingVue,
    CostingVue5,
    UpgradeVue,
    UpgradeVue2,
    BottomVue,
    BottomBossVue,
  },
  data() {
    return {
      bottomBox: false,
      bademon: false,
      options: [
        {
          value: '知识付费',
          label: '知识付费',
        },
        {
          value: '兴趣培训',
          label: '兴趣培训',
        },
        {
          value: '大健康',
          label: '大健康',
        },
        {
          value: 'K12教育',
          label: 'K12教育',
        },
        {
          value: '企业培训',
          label: '企业培训',
        },
        {
          value: '医疗美容',
          label: '医疗美容',
        },
      ],
      value: '',
      input: '',
      http: this.$getCookie('http'),
      TopUp: 0,
      dddddd: 0,
      input: '',
      mianfei: true,
      dialogVisible: false,
      screenWidth: true, // 判断pc,yd
      shijian: 0, // 埋点时间
      result: '',
    }
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.zhaungtai()
        if (val.path == '/') {
          this.dddddd = 1
          const cnzzScript = document.createElement('script')
          cnzzScript.type = 'text/javascript'
          cnzzScript.src = 'https://s4.cnzz.com/z_stat.php?id=1281288238'
          document.body.appendChild(cnzzScript)
        } else {
          this.dddddd = 0
        }
        if (oldVal.path != val.path) {
          this.$setItem('luyou', oldVal.path)
          report(false)
          this.shijian = 0
        }
        // this.activeIndex = this.$getItem('tad')
      },
      // 深度观察监听
      deep: true,
    },
    $router(to, from) {},
  },
  created() {
    this.zhaungtai()
    setInterval(() => {
      if (!this.$getItem('shijian')) {
        this.shijian = 0
      }
      this.shijian = this.shijian + 1
      this.$setItem('shijian', this.shijian)
    }, 1000)
    this.$setItem('luyou', this.$route.path)

    // const userAgent = navigator.userAgent
    // if (/mobile/i.test(userAgent) || /android/i.test(userAgent)) {
    //   this.screenWidth = false
    // } else {
    //   console.log('pc')
    // }
  },
  mounted() {
    // 获取referrer信息
    const referrer = document.referrer
    if (referrer === '') {
      // 在这里执行相应的逻辑
    } else {
      // 在这里执行相应的逻辑
    }

    window.addEventListener('unload', () => {
      report(false)
    })
    if (this.screenWidth) {
      window.addEventListener('scroll', this.handleScroll)
    }
    // const path = this.$route.path;
    // const parts = path.split('/');
    // const about = parts[parts.length - 1];
  },
  methods: {
    //提交留资信息
    submitPhone() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (this.input && this.value && ccc.test(this.input)) {
        axios
          .get(
            'https://manager-api.mischool.com.cn' +
              '/official/mail?' +
              'mobile=' +
              this.input +
              '&industry=' +
              this.value
          )
          .then((res) => {
            if (res.data.code === 200) {
              console.log('发送成功')
              this.bademon = false
              this.$message.success('提交成功')
              this.input = ''
              this.value = ''
            }
          })
      } else {
        this.$message.error('请选择行业或输入手机号')
      }
    },
    // 打开留资弹窗
    inquiry() {
      this.bademon = true
    },
    // 关闭留资弹窗
    unInquiry() {
      this.bademon = false
    },
    zhaungtai() {
      document.title = this.$route.meta.title
    },

    handleClick2(i) {
      this.$setItem('luyou', this.$route.path)
      report(true)
      this.$removeItem('shijian')
    },
    handleClick22() {
      let f = `侧边栏->免费试用`
      this.$setItem('luyou', this.$route.path)
      report(true, f)
      this.$removeItem('shijian')
    },
    // 回到顶部
    handleClickTop() {
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      })
    },
    // 判断显示与隐藏
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.dialogVisible) {
        this.dialogVisible = false
      }
      if (this.$route.path !== '/details' && this.$route.path !== '/details2') {
        // if (this.$route.path !== "/details" && this.$route.path !== '/about2') {

        var pageHeight = Math.max(
          document.body.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.clientHeight,
          document.documentElement.scrollHeight
        )
        var div = document.querySelector('.BossTop9') // 选择你要获取距离的div元素
        var distanceToBottom =
          document.body.scrollHeight - (div.offsetTop + div.offsetHeight) // 元素到底部的距离(下面元素的高度)
        var screenHeight = window.innerHeight //屏幕高度

        if (pageHeight - distanceToBottom - screenHeight < scrollTop) {
          this.mianfei = false
        } else {
          this.mianfei = true
        }
      }

      if (scrollTop > 470) {
        this.TopUp = 1
      }
      if (scrollTop < 470) {
        this.TopUp = 2
      }

      if (scrollTop > 100) {
        this.bottomBox = true
      }
      if (scrollTop < 100) {
        this.bottomBox = false
      }
    },
    dialNumber() {
      // var url = "tel:" +
      // window.location.href = url;
      const phoneNumber = ''
      // 创建一个新的电话链接
      const callLink = document.createElement('a')
      callLink.href = `tel:${phoneNumber}`
      callLink.innerHTML = '点击拨打电话'

      // 将电话链接添加到页面中
      document.body.appendChild(callLink)

      // 模拟点击电话链接
      callLink.click()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    // 手机号验证
    dianhuan() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (!ccc.test(this.input)) {
        this.$message.error('请正确填写联系方式！')
      } else {
        let data = {
          phone: this.input,
          industryId: '1562512233332768',
          uuid: this.$getItem('result'),
        }
        add(data).then((res) => {
          if (res.data.code == 200) {
            let f = `${fff(this.$route.path)}->底部->免费试用`
            this.$setItem('luyou', this.$route.path)
            report(false, f)
            this.dialogVisible = true
            this.input = ''
          }
        })
      }
    },
  },
  // 清空
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<!-- <style>
.named {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style> -->
<style lang="scss" scoped>
.screenWidth2222 {
  position: fixed;
  bottom: 0;
  z-index: 99;
}
.asdf ::v-deep .el-dialog {
  width: 470px !important ;
  height: 320px !important;
  border-radius: 8px;
}
.asdf ::v-deep .el-dialog__header {
  display: none;
}
.asdf ::v-deep .el-dialog__body {
  text-align: center;
  padding: 0;
}
.asdf .xxx_top {
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: #eb5b05;
  margin-bottom: 12px;
}
.asdf .xxx_topy {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  margin-bottom: 16px;
}
.asdf .xxx_topu {
  display: flex;
  justify-content: center;
  height: 40px;
}
.asdf .xxx_topu22 {
  width: 270px;
  height: 40px !important;
  background: #eb5b05;
  border-radius: 4px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  color: #ffffff;
}
.yueon3 {
  cursor: pointer !important;
  width: 150px;
  height: 40px;
  background: #eb5b05;
  border-radius: 69px 69px 69px 69px;
  opacity: 1;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  margin: 0 121px 0 40px;
}
.yueon ::v-deep .el-input__inner {
  width: 314px;
  height: 40px;
  font-size: 18px;
  padding: 0 40px;
  background: #ffffff;
  border-radius: 69px 69px 69px 69px;
  opacity: 1;
}
.yueon {
  width: auto;
}
.BossTop9 {
  // height: 125px;
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #c1c1c1;

  .BossTop8 {
    height: 60px;
    width: 5000px;
    background: url('../assets/数字人/38.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    .DivYou {
      color: #ffffff;
    }
  }
  .BossTop5 {
    width: 1440px;
    display: flex;
    align-items: center;
    justify-content: end;
    height: 100%;
    // flex-direction: column;
  }
  .YouBoss {
    height: 24px;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 24px;
  }
  .BossTop4 {
    width: 170px;
    height: 50px;
    background: #eb5b05;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 51px;
    text-align: center;
  }
}
.one_one {
  z-index: 1;
  width: 100%;
  height: 87px;
  background: url('../assets//yidong/26.png');
  background-size: 100% 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.one_one_1 {
  width: 100%;
  position: absolute;
  // bottom: 20px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.one_one_2 {
  display: flex;
  align-items: center;
  margin: 26px 0 0;
  color: #ffffff;
  font-size: 16px;
  img {
    width: 26px;
    height: 26px;
    margin: 0 8px 0 0;
  }
}
.consult {
  width: 160px;
  padding: 20px 5px;
  text-align: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 23%;
  right: 105px;
  z-index: 2000;
  display: none;
  img {
    width: 125px;
  }
}
.one_d:hover .consult {
  display: block !important;
}

.telephone {
  padding: 20px;
  text-align: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 38%;
  right: 105px;
  z-index: 2000;
  display: none;
  h4 {
    color: #0075ff;
    padding: 0;
    margin: 0;
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    margin-top: 20px;
    color: #303133;
  }
}
.one_d:hover .telephone {
  display: block !important;
}

::v-deep .el-link.is-underline:hover:after {
  border-bottom: 1px solid transparent;
}
.named {
  width: 100%;
  display: flex;
  justify-content: center;
}
.home {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;
  .navigationBar {
    position: fixed;
    top: 0;
    z-index: 2000;
    width: 100%;
  }
  .one_a {
    z-index: 100;
    position: fixed;
    height: 417px;
    right: 0px;
    top: 50vh;
    margin-top: -209px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .one_b {
      height: 80px;
      margin-bottom: 15px;
    }
    .one_c {
      background: rgb(255, 255, 255);
      box-shadow: 0 1px 1px 1px rgba(167, 167, 167, 0.39);
      border-radius: 8px;
      padding-bottom: 10px;
      position: relative;
      .one_d {
        height: 70px;
        /* width: 64px; */
        margin: 0 4px;
        text-align: center;
        border-bottom: 2px solid #d9d9d9;
        border-radius: 1px;
        box-sizing: border-box;
        padding-top: 10px;
        .img {
          width: 23px;
          height: 23px;
          margin-bottom: 5px;
        }
        .div {
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #121221;
          line-height: 16px;
          cursor: default;
        }
        .div1 {
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #121221;
          line-height: 16px;
        }
      }
      .top {
        border-bottom: none;
      }
    }
  }
}
.topBack:hover {
  cursor: pointer;
}
.topBack {
  animation-duration: 1s;
  background: #ffffff;
  padding: 10px 6px;
  margin-top: 25px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 0 0 1px rgba(167, 167, 167, 0.39);
  .img {
    width: 23px;
    height: 23px;
  }
  .div {
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #121221;
    line-height: 20px;
  }
}
.noShowBottom {
  display: none;
}
</style>
